/** @format */

import HomeWorkOutlined from '@mui/icons-material/HomeWorkOutlined';
import MarkEmailUnreadOutlined from '@mui/icons-material/MarkEmailUnreadOutlined';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Stack,
} from "@mui/material";
import React, { useState } from "react";
import { useAppSelector } from "../../../../app/hooks";
import {
  selectConstants,
} from "../../../../common/dropdowns/Api/constantSlice";
import MessageResponse from "../../../../common/feedback/messageResponse";
import CircularLoader from "../../../../common/loaders/circularLoader";
import { FeedbackDto } from "../../../../common/models/requests/FeedbackDto";
import { selectApplicant } from "../../ApplicantSlice";
import { ApplicationDetailsDto } from "../../Models";

interface Props {
  applicant: ApplicationDetailsDto | null;
}

function AddressBlock(props: {
  icon: React.ReactNode;
  title: string;
  children: React.ReactNode;
}) {
  return (
    <Stack spacing={1.25}>
      <Stack direction="row" spacing={1} alignItems="center">
        <Box
          sx={{
            width: 36,
            height: 36,
            borderRadius: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            bgcolor: (t) =>
              t.palette.mode === "light"
                ? "rgba(25, 118, 210, 0.08)"
                : "action.selected",
            color: "primary.main",
          }}>
          {props.icon}
        </Box>
        <Typography
          variant="overline"
          sx={{
            fontWeight: 700,
            letterSpacing: "0.08em",
            color: "text.secondary",
          }}>
          {props.title}
        </Typography>
      </Stack>
      <Box
        sx={{
          pl: { xs: 0, sm: 0 },
          typography: "body2",
          color: "text.primary",
          lineHeight: 1.6,
        }}>
        {props.children}
      </Box>
    </Stack>
  );
}

export default function AddressInfor({ applicant }: Props) {
  const constantsSelect = useAppSelector(selectConstants);
  const applicantSelect = useAppSelector(selectApplicant);
  const [feedback] = useState<FeedbackDto>({} as FeedbackDto);

  const getProvince = (key: number | string) => {
    if (constantsSelect.constantState) {
      const findProvince = constantsSelect.constantState.provinces.find(
        (x) => x.id === key
      );
      return findProvince?.description;
    }
    return "No Province Found";
  };

  return (
    <>
      <CircularLoader status={applicantSelect.loginState.status} />
      <MessageResponse feedback={feedback}  />
      {applicant && (
        <Card
          elevation={0}
          sx={{
            borderRadius: 3,
            border: "1px solid",
            borderColor: "divider",
            height: "100%",
          }}>
          <CardContent sx={{ p: { xs: 2, md: 2.5 } }}>
            <AddressBlock
              title="Residential address"
              icon={<HomeWorkOutlined fontSize="small" />}>
              <>
                <div>{applicant.address?.line1}</div>
                <div>{applicant.address?.line2}</div>
                <div>{applicant.address?.streetName}</div>
                <div>{applicant.address?.city}</div>
                <div>{getProvince(applicant.address?.provinceId)}</div>
                <div>{applicant.address?.code}</div>
              </>
            </AddressBlock>

            <Box sx={{ my: 3, borderTop: "1px dashed", borderColor: "divider" }} />

            <AddressBlock
              title="Postal address"
              icon={<MarkEmailUnreadOutlined fontSize="small" />}>
              <>
                <div>{applicant.address?.postalAddress}</div>
                <div>{applicant.address?.postalCity}</div>
                <div>{getProvince(applicant.address?.postalProvinceId)}</div>
                <div>{applicant.address?.postalCode}</div>
              </>
            </AddressBlock>
          </CardContent>
        </Card>
      )}
    </>
  );
}
